import styled from '@emotion/styled';
import { vars } from '@teamsparta/stack-tokens';
export const Container = styled.div`
  position: relative;
  height: 6px;
  margin: 0;
  * {
    margin: 0;
  }
`;
export const GrayBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 6px;
  background-color: ${vars.neutral[20]};
  border-radius: 20px;
`;
export const Progress = styled.div<{
  initProgressRate: number;
  maxProgressRate: number;
  progress: number;
  maxProgress: number;
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: ${({ initProgressRate, maxProgressRate, progress, maxProgress }) =>
    initProgressRate +
    (progress / maxProgress) * (maxProgressRate - initProgressRate)}%;
  height: 6px;
  background-color: ${vars.brand.default};
  border-radius: 20px;
  transition: width 0.3s ease-in-out;
`;
